import { notification } from 'antd'
import moment from 'moment'

import { soyshareApi } from '../../../../../services/api'
import { getMessage } from '../../../../../util/IntlMessages'

const api = soyshareApi.injectEndpoints({
  endpoints: (build) => ({
    getAction: build.query({
      query: ({ actionId, isMobile = false }) => ({
        url: `/actions/${actionId}`,
        params: { isMobile }
      }),
      providesTags: ['action-data'],
      transformResponse: ({ baseFields, customFields }) => {
        baseFields = Object.entries(baseFields).reduce((acc, [key, value]) => {
          /*
            [Suporte #46638] Visitas - Remover campo "Hora" do formulário principal
            USER STORY 10613 (AzureDevops)
          */
          // if (key === 'executionTime' && value) {
          //   acc[key] = new moment(
          //     moment(`${baseFields.executionDate} ${baseFields.executionTime}`, 'YYYY-MM-DD HH:mm:ss').toISOString()
          //   )
          // }
          if (isNaN(value) && moment(value, moment.ISO_8601, true).isValid()) {
            acc[key] = new moment(value)
          } else {
            acc[key] = value
          }
          return acc
        }, {})

        customFields = Object.entries(customFields).reduce((acc, [key, value]) => {
          if (isNaN(value) && moment(value, moment.ISO_8601, true).isValid()) {
            acc[key] = new moment(value)
          } else {
            acc[key] = value
          }
          return acc
        }, {})

        return { baseFields, customFields }
      }
    }),

    createAction: build.mutation({
      query: ({ payload }) => ({ url: '/actions/v2', method: 'POST', body: payload }),
      invalidatesTags: ['action-data'],
      onQueryStarted: async (_, { queryFulfilled }) => {
        try {
          await queryFulfilled
          notification.success({
            description: getMessage('successStoreActions'),
            message: getMessage('sweetAlerts.success')
          })
        } catch (error) {
          notification.error({
            description: getMessage('errorStoreAction'),
            message: getMessage('sweetAlerts.error')
          })
        }
      }
    }),

    updateAction: build.mutation({
      query: ({ actionId, payload }) => ({ url: `/actions/v2/${actionId}`, method: 'PUT', body: payload }),
      invalidatesTags: ['action-data'],
      onQueryStarted: async (_, { queryFulfilled }) => {
        try {
          await queryFulfilled
          notification.success({
            description: getMessage('successUpdateActions'),
            message: getMessage('sweetAlerts.success')
          })
        } catch (error) {
          notification.error({
            description: getMessage('errorUpdateAction'),
            message: getMessage('sweetAlerts.error')
          })
        }
      }
    })
  })
})

export const { useGetActionQuery, useCreateActionMutation, useUpdateActionMutation } = api
